var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('date-picker',{attrs:{"box-probs":_vm.boxProbs,"field":"from","label":_vm.$t('mentoring_start')}}),_c('date-picker',{attrs:{"box-probs":_vm.boxProbs,"field":"to","label":_vm.$t('mentoring_end')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }